import { Instagram as PostItemLoader } from 'react-content-loader';

interface IProps {
  className?: string;
}

export const AnglerPostsViewLoader = ({ className }: IProps) => (
  <div className={`${className} flex flex-col gap-4`}>
    <PostItemLoader uniqueKey="AnglerPostsView-loader-1" />
    <PostItemLoader uniqueKey="AnglerPostsView-loader-2" />
  </div>
);
